class Timer {
	constructor(elem) {
		this.data = {
			el: elem,
			days: elem.find("[data-timer-d]"),
			hours: elem.find("[data-timer-h]"),
			minutes: elem.find("[data-timer-m]"),
			seconds: elem.find("[data-timer-s]"),
			date: elem.data("date"),
		};
	}

	init() {
		let countDownDate = new Date(this.data.date).getTime();

		let x = setInterval(() => {
			let now = new Date().getTime();
			let distance = countDownDate - now;
			let days = Math.floor(distance / (1000 * 60 * 60 * 24));
			let hours = Math.floor(
				(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
			);
			let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			let seconds = Math.floor((distance % (1000 * 60)) / 1000);

			if (hours < 10) {
				hours = `0${hours}`;
			}

			if (minutes < 10) {
				minutes = `0${minutes}`;
			}

			if (seconds < 10) {
				seconds = `0${seconds}`;
			}

			this.data.days.text(days + "д");
			this.data.hours.text(hours + "ч");
			this.data.minutes.text(minutes + "м");
			this.data.seconds.text(seconds + "с");

			if (distance < 0) {
				clearInterval(x);
				this.data.el.html("");
				this.data.el.addClass("d-none");
			}
		}, 1000);
	}
}

$(document).ready(() => {
	let timers = [];

	if ($("[data-timer]").length > 0) {
		$("[data-timer]").each(function(i) {
			timers[i] = new Timer($(this));
			timers[i].init();
		});
	}
});
